import { status } from './plusMinusQuantity';
import { getSectionsToRenderByUpdate, getSectionsToRenderByPDP } from './cartSections';
import finalSale from './finalSale';

// Track previous cart state for bi-directional recommendations switching
// Initialize from window.cart if available (set by Liquid on page load)
let previousCartHasItems = window.cart?.item_count > 0 ?? null;

export const sectionsRendering = (sections, { cartItemKey, cartData }) => {
  let getSectionsToRender;
  if (window.location.pathname !== '/cart') {
    getSectionsToRender = getSectionsToRenderByPDP(cartItemKey);
  } else {
    getSectionsToRender = getSectionsToRenderByUpdate();
  }

  return getSectionsToRender.forEach((section) => {
    if (section.reused) {
      // If the section is reused or employed in multiple places across the site
      // we need to replace all elements with the same ID. For example, cart-indicator
      const elementsToReplace = document.querySelectorAll(`#${section.id}`);

      return elementsToReplace.forEach((element) => {
        const subElement = element.querySelector(section.selector); // we might want to replace a sub-element
        if (subElement) {
          subElement.innerHTML = getSectionInnerHTML(sections[section.section], section.selector);
          return;
        }

        element.innerHTML = getSectionInnerHTML(sections[section.section], section.selector);
      });
    }
    const elementToReplace =
      document.getElementById(section.id)?.querySelector(section.selector) ||
      document.getElementById(section.id) ||
      document.querySelector(`div[id*="${section.id}"]`);
    if (!elementToReplace) {
      return;
    }

    // section[needs] is a property that will help us to choose some cart attribute and apply a validation
    // it will help us to know whether we must rendering that section or we can ingore it. It could be expanded to use either Object or Array
    if (section.needs === 'item_count') {
      if (cartData.item_count !== 0) {
        return;
      }
    }
    elementToReplace.innerHTML = getSectionInnerHTML(sections[section.section], section.selector);
  });
};

const updateCartView = (cart, customEvent, in_background) => {
  if (status.debouncing) {
    return;
  }

  if (!in_background) {
    let cartOptions = cart;

    // Goes over it if customEvent came as parameter and if it brought some quickView too
    // it would tweak cartOptions object
    if (customEvent && customEvent.quickView) {
      cartOptions = {
        ...cartOptions,
        quickView: customEvent.quickView,
      };
    }
    if (customEvent && customEvent.quickAdd) {
      cartOptions = {
        ...cartOptions,
        quickAdd: {
          ...customEvent.quickAdd,
        },
      };
    }
    document.dispatchEvent(new CustomEvent('cartWillUpdate', { detail: cartOptions }));
  }

  // Guard condition, stops here because the rest of tasks are part of cart page. Hence, these are not needed to be run in other pages.
  if (window.location.pathname !== '/cart') return;

  // Optimizely Test
  const dataCartEmpty = document.querySelector('[data-cart-empty]');
  if (dataCartEmpty) {
    if (window.location.pathname === '/cart') {
      if (cart.item_count === 0) {
        dataCartEmpty.style.display = 'block';
      } else {
        dataCartEmpty.style.display = 'none';
      }
    }
  }

  // It's currently employed for specific event in the cart such as update any quantity, edit any item and remove any item
  // because under these scenario the cart object bring the entire data. It means, it contains all the items in the cart.
  // However, add an item to the cart won't bring the entire data. It means, all items won't come in the cart response.
  // So, we'll employ customEvent argument as flag, it will help to know when a add item to the cart invoked this function.
  if (!customEvent) {
    window.cart = cart;
  }

  // Update Final Sale states
  finalSale();

  // Handle bi-directional cart recommendations state change
  refreshRecommendations(cart);
};

export function refreshRecommendations(cart) {
  const currentHasItems = cart.item_count > 0;

  if (previousCartHasItems === null) {
    previousCartHasItems = currentHasItems;
    return;
  }

  // Prevent refreshing Recommendations more than once if cart already has units
  if (previousCartHasItems && currentHasItems) return;

  const constructorRec = document.querySelector('[data-cnstrc-recommendations][data-recommendations]');
  const secondaryPodScript = document.querySelector('script[data-secondary-pod-id]');
  const constructorRecTitle = document.querySelector('h2.product-rec-c-heading');
  const secondaryHeadingScript = document.querySelector('script[data-secondary-heading-text]');

  if (!constructorRec || !secondaryPodScript) return;

  // Get current and secondary values
  const currentPodId = constructorRec.getAttribute('data-cnstrc-recommendations-pod-id');
  const currentHeadingText = constructorRecTitle?.textContent || '';
  const secondaryPodId = secondaryPodScript.dataset.secondaryPodId;
  const secondaryHeadingText = secondaryHeadingScript?.dataset.secondaryHeadingText || '';

  // Swap: current becomes secondary, secondary becomes current
  constructorRec.setAttribute('data-cnstrc-recommendations-pod-id', secondaryPodId);
  if (constructorRecTitle) constructorRecTitle.textContent = secondaryHeadingText;
  secondaryPodScript.dataset.secondaryPodId = currentPodId;
  if (secondaryHeadingScript) secondaryHeadingScript.dataset.secondaryHeadingText = currentHeadingText;

  constructorRec.querySelectorAll('.product-rec-c-carousel__product-card').forEach((card) => card.remove());

  constructorRec.setAttribute('data-cnstrc-result-id', '');
  constructorRec.setAttribute('data-cnstrc-num-results', '');

  const markersContainer = constructorRec.parentElement.querySelector('.carousel-c-scroll__markers');
  if (markersContainer) markersContainer.innerHTML = '';

  // Re-fetch recommendations with new pod once the lazy-loaded chunk is ready
  window.loadRecommendations?.()?.then(() =>
    window.recommendations?.enqueue({
      bypassPlaceholder: true,
      reset: true,
      ignoreQueuesProcessed: true,
    }),
  );

  previousCartHasItems = currentHasItems;
}

export function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

export default function (cart, customEvent = null, in_background = false) {
  return cart && updateCartView(cart, customEvent, in_background);
}
